import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { createAppQueryClient } from './lib/createAppQueryClient';
import { preconnectBackendOrigins } from './lib/preconnectBackendOrigins';
import { getRouter } from './router';

preconnectBackendOrigins();

const queryClient = createAppQueryClient();
const router = getRouter({
  queryClient,
});
const rootElement = readRootElement();

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);

function readRootElement() {
  const element = document.getElementById('root');

  if (element === null) {
    throw new Error('Unable to find the app root element.');
  }

  return element;
}
